/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solvent`)
};

const es_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disolvente`)
};

const de_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lösungsmittel`)
};

const nl_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oplosmiddel`)
};

const fr_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solvant`)
};

const it_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solvente`)
};

const pt_br2_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solvente`)
};

const pt_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solvente`)
};

const ja_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶媒`)
};

const zh_bp_solvent = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶剂`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_solvent = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_solvent(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_solvent", locale)
	if (locale === "en") return en_bp_solvent(inputs)
	if (locale === "es") return es_bp_solvent(inputs)
	if (locale === "de") return de_bp_solvent(inputs)
	if (locale === "nl") return nl_bp_solvent(inputs)
	if (locale === "fr") return fr_bp_solvent(inputs)
	if (locale === "it") return it_bp_solvent(inputs)
	if (locale === "pt-BR") return pt_br2_bp_solvent(inputs)
	if (locale === "pt") return pt_bp_solvent(inputs)
	if (locale === "ja") return ja_bp_solvent(inputs)
	return zh_bp_solvent(inputs)
};